import React from "react";
import { Link } from "react-router-dom";

const Add = () => {
  return (
    <div>
      <div className="adminContent">
        <div className="grid grid-cols-3 gap-4 md:grid-cols-3 p-2 bg-white py-12 px-6 rounded-lg">
          <Link
            to="artist"
            className="focus:outline-black text-black font-bold text-2xl py-6 px-4 border-b-4 border-blue-600 bg-blue-50 hover:bg-blue-400 block text-center cursor-pointer"
          >
            Artist
          </Link>
          <Link
            to="collection"
            className="focus:outline-black text-black font-bold text-2xl py-6 px-4 border-b-4 border-gray-600 bg-gray-50 hover:bg-gray-400 block text-center cursor-pointer"
          >
            Collection
          </Link>
          <Link
            to="categorie"
            className="focus:outline-black text-black font-bold text-2xl py-6 px-4 border-b-4 border-green-600 bg-green-50 hover:bg-green-400 block text-center cursor-pointer"
          >
            Category
          </Link>
          <Link
            to="art"
            className="focus:outline-black text-black font-bold text-2xl py-6 px-4 border-b-4 border-red-600 bg-red-50 hover:bg-red-400 block text-center cursor-pointer"
          >
            Art
          </Link>
          <Link
            to="member"
            className="focus:outline-black text-black font-bold text-2xl py-6 px-4 border-b-4 border-yellow-600 bg-yellow-50 hover:bg-yellow-400 block text-center cursor-pointer"
          >
            Member
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Add;
